import React from 'react'
import { 
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { PracticaLabItem } from './PracticaLabItem';

const useStyles = makeStyles((theme) => ({
  grid: {
    paddingTop: 15,
    paddingLeft: 25,
    paddingRight: 25,
    paddingBottom: 15,
    display: 'inline-block',
  }
}));

export const PracticasLaboratorioSeleccionadas = () => {
  const { practicasSeleccionadas: practicas } = useSelector((state) => state.laboratorio);
  const classes = useStyles();

  const totalAutorizado = practicas.filter(s => s.autorizada).reduce((acum, item) => {
    return acum + (item.exento ? 0 : item.importeCoseguro);
  }, 0);

  const totalAuditoria = practicas.filter(s => !s.autorizada).reduce((acum, item) => {
    return acum + (item.exento ? 0 : item.importeCoseguro);
  }, 0);

  return (
    <>
      {practicas.length > 0 ? (
        <Table size={"small"}>
          <TableHead
            style={{ display: "table", width: "98.5%", tableLayout: "fixed" }}
          >
            <TableRow>
              <TableCell style={{ width: "50%" }}>Nombre Practica</TableCell>
              <TableCell style={{ width: "10%" }}>Cantidad</TableCell>
              <TableCell style={{ width: "15%" }}>Autorizada</TableCell>
              <TableCell style={{ width: "10%" }}>Exento</TableCell>
              <TableCell style={{ width: "15%" }}>$ Coseguro</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            style={{ display: "block", maxHeight: "29rem", overflowY: "auto" }}
          >
            {practicas.map((practica, index) => {
              return (
                <PracticaLabItem
                  key={index}
                  index={index}
                  practica={practica}
                  cantidadDefault={practica.cantidad}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <div style={{ fontStyle: "italic" }}>No hay practicas</div>
      )}
      <Grid container style={{textAlign: 'center'}}>
        <Grid item xs={6}>
          <h3 className={classes.grid} style={{backgroundColor: 'springgreen'}}>Importe Autorizadas: $ {totalAutorizado}</h3>
        </Grid>
        <Grid item xs={6}>
          <h3 className={classes.grid} style={{backgroundColor: 'tomato'}}>Importe Auditoria: $ {totalAuditoria}</h3>
        </Grid>
      </Grid>    
    </>
  )
}
